import { TelegramProductShortResponseDto } from '@/generated';
import clsx from 'clsx';
import { ProductBigPreview } from '../../shared/Product/productBigPreview';
import { AdViewSource } from '@/utils/adViewSource';
import { arrangeItemsExtended } from '@/utils/sortProducts';

type Props = {
  products: TelegramProductShortResponseDto[];
  isMobileDevice?: boolean;
};

export function ServerFeed({ products, isMobileDevice = false }: Props) {
  const itemsArrayed = arrangeItemsExtended(products, isMobileDevice ? 2 : 4);
  const firstRowsCount = isMobileDevice ? 3 : 2;
  const first = itemsArrayed.slice(0, firstRowsCount).flat(2);
  const second = itemsArrayed.slice(firstRowsCount).flat(2);

  const renderProduct = (product: TelegramProductShortResponseDto, priority: boolean) => (
    <div className={clsx({ 'col-[span_2]': product.isPremium })} key={product.id}>
      <ProductBigPreview
        product={product}
        priority={priority}
        showFavorite={false}
        adViewSource={AdViewSource.MainPage}
      />
    </div>
  );

  return (
    <>
      <div className='w-full grid md:grid-cols-4 grid-cols-2 md:gap-[16px] gap-[12px] gap-y-[16px] md:mt-[40px] mt-[16px]'>
        {first.map((product, index) => renderProduct(product, index < 4))}
      </div>
      <div className='w-full grid md:grid-cols-4 grid-cols-2 md:gap-[16px] gap-[12px] gap-y-[16px] md:mt-[90px] mt-[20px]'>
        {second.map((product) => renderProduct(product, false))}
      </div>
    </>
  );
}
